export const currencies = (state) => {
  return state.currencies ? state.currencies : []
}
